import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from '@emailjs/browser';

const ContactSection = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    title: "",
    message: ""
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      title: formData.title,
      message: formData.message,
    };

    emailjs.send(
      'service_b9uzpeq',
      'template_yrprrqq',
      templateParams,
      'shbwQ8xiHnHuPWpT7'
    )
    .then(() => {
       setFormData({ name: "", email: "", title: "", message: "" });
       // Send the visitor's name along so the thank-you page can greet them
       navigate('/thank-you', { state: { name: templateParams.from_name } });
    }, (err) => {
       alert('FAILED... Please try again later.');
       console.log('FAILED...', err);
    })
    .finally(() => {
       setIsSending(false);
    });
  };

  return (
    <div className="container-fluid py-5 mb-5">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style={{ maxWidth: "600px" }}>
          <h5 className="text-primary">Get In Touch</h5>
          <h1 className="mb-3">Contact us for expert guidance</h1>
        </div>

        <div className="contact-detail position-relative p-5">
          <div className="row g-5 mb-5 justify-content-center">
            {/* Address, Phone, Email UI stays exactly as you had it */}
            {/* ... */}
          </div>

          <div className="row g-5">
            {/* Google Map */}
            <div className="col-lg-6 wow fadeIn" data-wow-delay=".3s">
              <div className="p-5 h-100 rounded contact-map">
                <iframe
                  className="rounded w-100 h-100"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.291818952413!2d-1.8415167221740276!3d52.45574227204437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2f972f9cca636889%3A0xd1a43c651689517!2sUnigenius%20Consultants!5e0!3m2!1sen!2sin!4v1769949331079!5m2!1sen!2sin"
                  style={{ border: 0, minHeight: "350px" }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Map"
                ></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-6 wow fadeIn" data-wow-delay=".5s">
              <form onSubmit={handleSubmit} className="p-5 rounded contact-form bg-light">
                <div className="mb-4">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control border-0 py-3"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="mb-4">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control border-0 py-3"
                    placeholder="Your Email"
                    required
                  />
                </div>
                <div className="mb-4">
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-control border-0 py-3"
                    placeholder="Your Phone No."
                    required
                  />
                </div>
                <div className="mb-4">
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    className="form-control border-0 py-3"
                    placeholder="Title"
                    required
                  />
                </div>
                <div className="mb-4">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-100 form-control border-0 py-3"
                    rows="6"
                    placeholder="Message"
                    required
                  ></textarea>
                </div>
                <div className="text-start">
                  <button
                    className="btn bg-primary text-white py-3 px-5"
                    type="submit"
                    disabled={isSending}
                  >
                    {isSending ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;